import React,{ useEffect, useState } from 'react'
import TrustBox from '../components/TrustBox';
import CheckDescrpition from '../components/HomeAccordian'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaLock, FaShieldAlt, FaHistory, FaMoneyBillWave, FaCarCrash, FaCheckCircle, FaBolt, FaEnvelope, FaSearch } from 'react-icons/fa';
import './styling/Home.css';

export default function Home() {
    const [reg, setReg] = useState('')
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const isV2 = true;
    const navigateFindPage = (registration) => {
        if(!isV2){
            navigate(`/carfinder?reg=${registration}`);
        } else{
            navigate(`/fullmotcheck?reg=${registration}`);
        }
    };

    useEffect(()=> {
      const wakeLambda = async () => {
          await fetch(process.env.REACT_APP_BASE_URL + '/Ping/wake', {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
          });
      }
      wakeLambda()
    }, [])

    let carNotfound = searchParams.get("carnotfound")

    return (
        <div className='main'>
            <div className='hero-section'>
                <div className='checks-badge'>
                    <FaCheckCircle className='badge-icon' />
                    <span>10,000+ vehicle checks completed</span>
                </div>
                <h1 className='hero-title'>Check any UK vehicle</h1>
                <p className='hero-subtitle'>Avoid hidden problems. Buy with confidence.</p>

                <div className='search-container'>
                    <form className='search-box' onSubmit={e => { e.preventDefault(); navigateFindPage(reg); }}>
                        <FaSearch className='search-icon' />
                        <input
                            type="text"
                            maxLength="8"
                            className='search-input'
                            onChange={e => setReg(e.target.value.split(" ").join(""))}
                            placeholder="Enter registration"
                        />
                        <button type='submit' className='search-button'>Find</button>
                    </form>
                    {carNotfound && <p className='car-not-found'>Car not found</p>}
                    <div className='search-meta'>
                        <span><FaLock style={{ marginRight: 4 }} />Secure checkout</span>
                        <span>·</span>
                        <span><FaBolt style={{ marginRight: 4 }} />Instant results</span>
                        <span>·</span>
                        <span>£7.99 per check</span>
                    </div>
                </div>

                <div className='check-types'>
                    <div className='check-type-item'>
                        <FaShieldAlt className='check-type-icon' />
                        <span className='check-type-label'>DVLA Data</span>
                        <span className='check-type-sub'>Official source</span>
                    </div>
                    <div className='check-type-item'>
                        <FaHistory className='check-type-icon' />
                        <span className='check-type-label'>MOT History</span>
                        <span className='check-type-sub'>Full history</span>
                    </div>
                    <div className='check-type-item'>
                        <FaMoneyBillWave className='check-type-icon' />
                        <span className='check-type-label'>Finance Check</span>
                        <span className='check-type-sub'>Outstanding finance</span>
                    </div>
                    <div className='check-type-item'>
                        <FaCarCrash className='check-type-icon' />
                        <span className='check-type-label'>Write-off Check</span>
                        <span className='check-type-sub'>Insurance records</span>
                    </div>
                </div>
            </div>

            <TrustBox />

            <div className='trust-section'>
                <h2 className='trust-title'>Trusted by thousands of car buyers</h2>
                <p className='trust-description'>Join over 10,000 people who have checked a vehicle with us.</p>
                <div className='plate'>AB01 CDE</div>
            </div>

            <CheckDescrpition />

            <div className='footer-badges'>
                <div className='footer-badge'>
                    <FaLock className='footer-badge-icon' />
                    <span>Secure &amp; Encrypted</span>
                    <small>Your data is always safe</small>
                </div>
                <div className='footer-badge'>
                    <FaShieldAlt className='footer-badge-icon' />
                    <span>DVLA Data Source</span>
                    <small>100% official data</small>
                </div>
                <div className='footer-badge'>
                    <FaBolt className='footer-badge-icon' />
                    <span>Instant Results</span>
                    <small>Results in seconds</small>
                </div>
                <div className='footer-badge'>
                    <FaEnvelope className='footer-badge-icon' />
                    <span>Customer Support</span>
                    <small><a href="mailto:info@carinformation.co.uk">info@carinformation.co.uk</a></small>
                </div>
            </div>

            <br />
            <h5><b><a href="https://www.carinformation.co.uk/samplecheck">View Full Report Sample</a></b></h5>
        </div>
    );
}
